import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { IAnswer } from "@/types/types";
import { type FC } from "react";
import Carousel from "@/components/carousel/Carousel";
import { Pill } from "@/components/pill/Pill";
import { useDate } from "@/hooks/use-date/useDate";

import { useQuery } from "@tanstack/react-query";
import { getImages } from "@/lib/services/images";

interface AnswerModalContentProps {
  item: IAnswer;
  edition: boolean;
  editable?: boolean;
  edit?: () => void;
}

const AnswerModalContent: FC<AnswerModalContentProps> = ({
  item,
  editable,
  edit,
}) => {
  const translate = useTranslate();
  const { formatDate } = useDate();

  const { data: imageUrls } = useQuery({
    queryKey: ["answer", item.id],
    queryFn: () => getImages({ images: item.images }),
    placeholderData: [],
  });

  return (
    <div className="space-y-4">
      <Carousel
        urls={imageUrls}
        startIndex={0}
        loop
        className="w-full"
        panelClassName="h-80 md:h-[28rem]"
      />
      <div className="flex justify-between items-center">
        <div className="flex space-x-2">
          <Pill
            label={translate("ready")}
            icon="check"
            className="bg-[#ADE1C7]"
            iconClassName="size-3"
          />
          <Pill
            label={item.status}
            icon="comment"
            className="bg-white border border-ib-gray-light-1"
            iconClassName="size-3"
          />
        </div>
        <div className="flex space-x-1 text-sm">
          <p className=" text-ib-gray-main">{translate("lastUpdate")}:</p>
          <span className="text-ib-gray-darkest">
            {formatDate(item?.updatedAt?.toString())}
          </span>
        </div>
      </div>
      {item.comment && (
        <div>
          <p className="text-md text-ib-gray-darkest">{item.comment}</p>
        </div>
      )}
      {!item.comment && editable && (
        <button
          type="button"
          onClick={edit}
          className="w-full border border-dashed rounded-sm"
        >
          <p className="text-ib-gray-dark-2 text-center hover:underline">
            {translate("addCommentOrImages")}
          </p>
        </button>
      )}
    </div>
  );
};

export default AnswerModalContent;
